import SelectBox from "../select-box/select-box";

export default class OrderSelectBox extends SelectBox {
    constructor($originEl, options) {
        options = options || {};
        options.className = 'order-select-box';

        super($originEl, options);
    }
}
